import { SAME_LOCATION } from "@/config/app-constant";
import { ANNUAL_MULTI_TRIP } from "@/constants";

import { useTravelDatesContext } from "../../providers/travel-dates.provider";
import {
  checkCurentLocation,
  dateDifferenceInDays,
  formatDate,
} from "../../utils/date-picker.utils";

export function useValidationModalHandlers() {
  const {
    pendingDate,
    quotePolicyType,
    travelDates,
    setCancelBtnClick,
    setIsModalOpen,
    setModalType,
    setPendingDate,
    setTravelDates,
    fromLocation,
    toLocation,
  } = useTravelDatesContext();

  const handleSameDayConfirm = () => {
    setIsModalOpen(false);
    if (quotePolicyType === ANNUAL_MULTI_TRIP && pendingDate) {
      setTravelDates({
        validate: true,
        startDate: pendingDate,
        endDate: pendingDate,
      });
      setPendingDate(null);
      return;
    }
    if (
      formatDate(travelDates.startDate as Date) === formatDate(new Date()) &&
      dateDifferenceInDays(
        travelDates.startDate as Date,
        travelDates.endDate as Date
      ) <= 1 &&
      checkCurentLocation(fromLocation, toLocation)
    ) {
      setIsModalOpen(true);
      setModalType(SAME_LOCATION);
      return;
    }
    setTravelDates((prev) => ({
      ...prev,
      validate: true,
    }));
  };

  const handleSameDayCancel = () => {
    setIsModalOpen(false);
    setTravelDates({
      validate: false,
      startDate: null,
      endDate: null,
    });
    setCancelBtnClick(true);
  };

  return {
    handleSameDayConfirm,
    handleSameDayCancel,
  };
}
